import { render } from "./ProductSelectorList.vue?vue&type=template&id=28770786&scoped=true&ts=true"
import script from "./ProductSelectorList.vue?vue&type=script&lang=ts"
export * from "./ProductSelectorList.vue?vue&type=script&lang=ts"

import "./ProductSelectorList.vue?vue&type=style&index=0&id=28770786&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28770786"]])

export default __exports__